import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { accountsClient } from '../../../../utils/apollo/api'
import { useGroupsActionsList } from '../../../../utils/actions/groups/list'
import { useGroupsState } from '../_load/GroupsLoader'
import { useOpenEditGroupModal } from '../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import ListCounter from '../../../../components/helpers/ListCounter'
import Text from '../../../../packages/kiti/components/presentation/Text'

const GroupsTable = props => {
  const { t } = useTranslation('listGroups')
  const { userGroups: data } = useGroupsState()
  const openEditModal = useOpenEditGroupModal()

  const columns = [
    {
      label: t('name'),
      headerSideContent: (
        <>
          <ListCounter client={accountsClient} entity="users" filterName="UserFilter" size="xsmall" bold />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 4,
      render: (name, record) => <Text onClick={() => openEditModal({ id: record.id })}>{name}</Text>
    },

    {
      label: t('actions'),
      width: 5,
      render: useRowActionsColumn(useGroupsActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" {...props} />
}

export default GroupsTable
